var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { findTimezoneOption, getTimezoneOptions } from '@web/utility/timezones';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
export function TimezoneSection(_a) {
    var onChange = _a.onChange, selectedTimeZone = _a.selectedTimeZone;
    var t = useTranslation().t;
    var timezoneOptions = useMemo(function () { return getTimezoneOptions(selectedTimeZone); }, [selectedTimeZone]);
    var selectedOption = findTimezoneOption(selectedTimeZone, timezoneOptions);
    return (_jsxs("div", __assign({ className: "flex flex-col gap-3 sm:rounded-lg p-3 sm:p-6 shadow sm:w-1/2" }, { children: [_jsx("h3", __assign({ className: "text-sm sm:text-xl leading-6 font-semibold text-gray-900" }, { children: t('timezone.title') })), _jsx("div", __assign({ className: "max-w-80" }, { children: _jsx(Select, { selected: selectedOption, onChange: onChange, options: timezoneOptions, withSearchField: true }) })), _jsx("div", __assign({ className: "text-sm sm:text-sm text-gray-500 w-2/3" }, { children: t('generalSettings.timezoneDescription') }))] })));
}
export default TimezoneSection;
